import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { HelpContent } from '../HelpContent';
import { jsx as _jsx } from "react/jsx-runtime";
export function SelectStepItem({
  item,
  label,
  params,
  onChange
}) {
  var _item$tooltip;
  const value = params[item.name];
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    required: item.required,
    tooltip: (_item$tooltip = item.tooltip) === null || _item$tooltip === void 0 ? void 0 : _item$tooltip.text,
    help: /*#__PURE__*/_jsx(HelpContent, {
      helpData: item.help
    }),
    children: /*#__PURE__*/_jsx(Select, {
      options: item.options.map(option => ({
        text: option.label,
        value: option.value
      })),
      value: value,
      onChange: event => onChange(item.name, event.target.value),
      menuWidth: "auto"
    })
  });
}